import CssBaseline from '@mui/material/CssBaseline'
import type { ThemeProviderProps as MuiThemeProviderProps } from '@mui/material/styles'
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles'
import { useMemo } from 'react'
import { ToastContainer } from 'react-toastify'
import { createTheme } from './create-theme'
import type {} from './extend-theme-types'
import 'react-toastify/dist/ReactToastify.css'
import '@/styles/toastify.css'

export type ThemeProviderProps = Omit<MuiThemeProviderProps, 'theme'> & {}

export function ThemeProvider({ children, ...other }: ThemeProviderProps) {
  const theme = useMemo(() => createTheme(), [])

  return (
    <ThemeVarsProvider theme={theme} {...other}>
      <CssBaseline />
      <ToastContainer position='bottom-right' />
      {children}
    </ThemeVarsProvider>
  )
}
